// extracted by mini-css-extract-plugin
export default {"RefImgPopover":"VersionTips_RefImgPopover__kv20Y","RefImg":"VersionTips_RefImg__D8+OF"};